import { ReportableEventType } from '@willow/types-iso';

export const ReportableEventTypeToDisplayName: Record<ReportableEventType, string> = {
  breachLetterSent: 'Breach Letter Sent',
  completeBorrowerResponsePackage: 'Complete Borrower Response Package',
  solicitationLetterSent: 'Solicitation Letter Sent',
  reinstatement: 'Reinstatement',
  workoutInReview: 'Workout in Review',
  modificationInReview: 'Modification in Review',
  appealOfLoanModification: 'Appeal of Loan Modification',
  repaymentPlanInReview: 'Repayment Plan in Review',
  bankruptcyCourtClearanceObtained: 'Bankruptcy Court Clearance Obtained/Stay Lifted',
  bankruptcyPlanConfirmed: 'Bankruptcy Plan Confirmed',
  bankruptcyPropertySurrendered: 'Bankruptcy\u2013Property Surrendered',
  chapter13BankruptcyPlanPostPetition: 'Chapter 13 Bankruptcy Plan - Post-Petition Period Utilize',
  preFileMediation: 'Pre-File Mediation/Mediation',
  dateAdvisedPropertyListedForSale: 'Date Advised Property Listed for Sale',
  foreclosureSaleContinued: 'Foreclosure Sale Continued',
  foreclosureSaleScheduled: 'Foreclosure Sale Scheduled',
  judgmentOrDecreeEntered: 'Judgment or Decree Entered',
  thirdPartySale: 'Third\u2011Party Sale',
  contestedLitigatedForeclosure: 'Contested/Litigated Foreclosure',
  appraisalOrdered: 'Appraisal Ordered',
  inspectionOrdered: 'Inspection Ordered',
  assignment: 'Assignment',
  assumption: 'Assumption',
  chargeOff: 'Charge\u2011off',
  militaryIndulgence: 'Military Indulgence',
  mortgageRelease: 'Mortgage Release',
  probate: 'Probate',
  refinance: 'Refinance',
  shortSaleApprovedMarketingProperty: 'Short Sale Approved/Marketing Property',
  shortSaleApprovedOfferReceived: 'Short Sale Approved/Offer Received',
  shortSaleInReview: 'Short Sale in Review',
  ineligibleForShortSale: 'Ineligible for Short Sale',
  boardedDateOfFirstDelinquency: 'Date of First Delinquency (Override)',
};
